import React, { useState, useEffect } from 'react'
import { MpAnswerModel } from '../../../../model/knowledge.model'
import {
    MpCardAppIcon,
    MpCardGhIcon,
    MpCardLogoIcon,
    MpCardPageIcon,
    MpCardTitleIcon,
    UploadEditIcon,
} from '../../../../conf/images'
import './MpCardAnswer.css'
interface CardAnswerProps {
    finished?: boolean
    answer: string //CardAnswerModel
    completed?: boolean
    onConfirm?: (anwer: string) => any
    onCancel?: () => any
    onEdit?: () => void
    isLocked?: boolean
}
const MpCardAnswer: React.FC<CardAnswerProps> = (props) => {
    let { finished, answer = '{}', onConfirm, onCancel, onEdit } = props
    let [answerPlainObj, setAnswerPlainObj] = useState<MpAnswerModel>({
        title: '',
        Mp_App_Id: '',
        pagePath: '',
        username: '',
    })
    const [editCompleted, setEditCompleted] = useState(false)
    useEffect(() => {
        if (answer) {
            setAnswerPlainObj(JSON.parse(answer))
        }
    }, [answer])
    useEffect(() => {
        setEditCompleted(
            !!(
                answerPlainObj.title &&
                answerPlainObj.Mp_App_Id &&
                answerPlainObj.username
            )
        )
    }, [answerPlainObj])
    const hanelCardTitleChange = (e: any) => {
        setAnswerPlainObj({
            ...answerPlainObj,
            title: e.target.value,
        })
    }
    const hanelCardAppIdChange = (e: any) => {
        setAnswerPlainObj({
            ...answerPlainObj,
            Mp_App_Id: e.target.value,
        })
    }
    const hanelCardUsernameChange = (e: any) => {
        setAnswerPlainObj({
            ...answerPlainObj,
            username: e.target.value,
        })
    }
    const hanelCardPagePathChange = (e: any) => {
        setAnswerPlainObj({
            ...answerPlainObj,
            pagePath: e.target.value,
        })
    }
    if (finished) {
        return (
            <div
                className='mp-card-answer mp-card-answer--proto'
                onClick={onEdit}
            >
                <img className='mp-logo-icon' src={MpCardLogoIcon} alt='icon' />
                <p className='card-desc'>{answerPlainObj.title}</p>
                {!props.isLocked && (
                    <img
                        className='mp-edit-icon'
                        src={UploadEditIcon}
                        alt='icon'
                    />
                )}
            </div>
        )
    }

    const handleConfirm = () => {
        if (!editCompleted) {
            console.log('请完善信息')
            return
        }
        console.log(answerPlainObj)
        onConfirm && onConfirm(JSON.stringify(answerPlainObj))
    }
    return (
        <div className='mp-card-answer mp-card-answer--editing'>
            <div className='card-input-item'>
                <img className='item-icon' src={MpCardGhIcon} alt='icon' />
                <input
                    className='input'
                    type='text'
                    defaultValue={answerPlainObj.username}
                    placeholder='请输入小程序原始ID(必填)'
                    // value={answerPlainObj.title}
                    onChange={hanelCardUsernameChange}
                />
            </div>
            <div className='card-input-item'>
                <img className='item-icon' src={MpCardAppIcon} alt='icon' />
                <input
                    className='input'
                    type='text'
                    defaultValue={answerPlainObj.Mp_App_Id}
                    placeholder='请输入小程序APP_ID(必填)'
                    // value={answerPlainObj.description}
                    onChange={hanelCardAppIdChange}
                />
            </div>
            <div className='card-input-item'>
                <img className='item-icon' src={MpCardTitleIcon} alt='icon' />
                <input
                    className='input'
                    type='text'
                    placeholder='请输入小程序标题(必填)'
                    defaultValue={answerPlainObj.title}
                    onChange={hanelCardTitleChange}
                    // value={answerPlainObj.destination_url}
                />
            </div>
            <div className='card-input-item'>
                <img className='item-icon' src={MpCardPageIcon} alt='icon' />
                <input
                    className='input'
                    type='text'
                    placeholder='请输入子页面路径'
                    defaultValue={answerPlainObj.pagePath}
                    onChange={hanelCardPagePathChange}
                    // value={answerPlainObj.destination_url}
                />
            </div>
            <div className='mp-card-bottom'>
                <button onClick={onCancel}>取消</button>
                <button
                    className={`confirm ${editCompleted ? 'active' : ''}`}
                    onClick={handleConfirm}
                >
                    完成
                </button>
            </div>
        </div>
    )
}

export default MpCardAnswer
